import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { assetIcons } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import englishTranslations from "../../../i18n/translations/en";
import InlineSvg from "../inline-svg";
import { useUser } from "../../../context/user-context";

const BetPanel = ({ isDrawerOpen, toggleDrawer }) => {
  const { user, updateUser } = useUser();
  return (
    <Box
      onClick={toggleDrawer}
      sx={{
        height: 80,
        bgcolor: "#1A1A1A",
        borderTop: "1px solid #333",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // position: "absolute",
        width: "100%",
        // bottom: 0,
        zIndex: 1,
        position: "relative",
        // px: 2,
        cursor: "pointer",
      }}
    >
      <Box display={"flex"} ml={2}>
        <InlineSvg sx={{ mr: 1.5, mb: -0.3 }} url={assetIcons.dice} />
        <Box display={"flex-col"}>
          <Typography
            color={darkColors.primary}
            fontSize={fontSizes.heading3}
            fontFamily={"MontserratBold"}
            textAlign={"left"}
          >
            {englishTranslations.bet.betPanel}
          </Typography>
          <Typography
            color={darkColors.lightGray}
            fontSize={fontSizes.heading3}
            fontStyle={"italic"}
          >
            Your Wager:
            <InlineSvg sx={{ ml: 1, mb: -0.3 }} url={assetIcons.currencyIcon} />
            <Typography
              component={"span"}
              color={"white"}
              fontStyle={"initial"}
              ml={1}
            >
              {user.walletAmount}
            </Typography>
          </Typography>
        </Box>
      </Box>

      {/* <Typography color="white">Bet Panel</Typography> */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}>
        <IconButton size="small" sx={{ color: darkColors.buttonTop }}>
          {isDrawerOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default BetPanel;
